import { createFileRoute } from '@tanstack/react-router'
import { ExpensesPage } from '../../../components/ExpensesPage'

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

type ExpensesSearch = { asset_uid?: string }

export const Route = createFileRoute('/$org/expenses/')({
  // asset_uid narrows the list to one asset's lines, as GET /expenses does.
  validateSearch: (search: Record<string, unknown>): ExpensesSearch => ({
    asset_uid: typeof search.asset_uid === 'string' && UUID_RE.test(search.asset_uid) ? search.asset_uid : undefined,
  }),
  component: Expenses,
})

function Expenses() {
  const { asset_uid } = Route.useSearch()
  return <ExpensesPage assetUid={asset_uid} />
}
